// components
import Accounting from 'accounting';
import NumberInput from '~/components/v2/number-input.vue';
import DropDown from '~/components/v2/drop-down.vue';
import AdvertisingDisclosures from '~/components/v2/advertising-disclosures.vue';

// mixin
import LowestApr from '~/mixin/v2/lowest-apr';
import Redirection from '~/mixin/v2/redirection';
import InteractionTracking from '~/mixin/v2/interaction-tracking';

Accounting.settings.currency.format = {
    pos: '%s%v', // for positive values, eg. "$1.00" (required)
    neg: '-%s%v', // for negative values, eg. "-$1.00" [optional]
    zero: '%s%v', // for zero values, eg. "$0.00" [optional]
};

export default {
    props: {
        hideTooltip: {
            default: 0,
        },
    },
    computed: {
        DestinationURL() {
            return this.setDestinationBaseURL(); // in the future, we can append params to sent
        },
    },
    methods: {
        updateInitialInterestRate(val) {
            this.NewInterestRate = val;
        },
        formatFigure(figure) {
            return Accounting.formatMoney(figure, { symbol: '', precision: 0 });
        },
        unformatFigure(figure) {
            return Accounting.unformat(figure);
        },
        navigate(lenderId) {
            this.DestinationLinkOrId = `${this.DestinationLinkOrId}&userselectedlender=${lenderId}`;
            this.redirect();
        },
        formatToMoney(figure) {
            return Accounting.formatMoney(Math.abs(figure), { precision: 0 });
        },
        currencyFormatter(value) {
            const localValue = this.unformatFigure(value);
            const formatedValue = this.formatToMoney(localValue);
            return localValue < 0 ? `(${formatedValue})` : formatedValue;
        },
    },
    components: {
        NumberInput,
        DropDown,
        AdvertisingDisclosures,
    },
    mixins: [LowestApr, Redirection, InteractionTracking],
};
